import * as React from "react";
import { Slider, Typography } from "@mui/material";
import moment from "moment";
import { SLIDER_STATE } from "globalStore/globalStore";
import { useHookstate } from "@hookstate/core";
import styled from "styled-components";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

function valuetext(value) {
  return value;
}

const getDate = (date) => {
  return `${moment(date).format("dd LT")}`;
};
export default function StyledSlider() {
  const { t } = useTranslation();
  const { siteSettingsData } = useSelector((state) => state.commonReducers) || [];
  const { sliderState } = useHookstate(SLIDER_STATE);
  const [sliderValue, setSliderValue] = React.useState([-3.15, 0]);

  React.useEffect(() => {
    let localLocationSliderValue = localStorage.getItem("locationSliderValue")
    if (localLocationSliderValue)
      setSliderValue(JSON.parse(localLocationSliderValue))
  }, [])

  React.useEffect(() => {
    let temVal = [
      moment(
        moment()
          .utc()
          .utcOffset(-siteSettingsData?.TimeZoneOffset)
          .subtract(-sliderValue[0], "hours")
      ).valueOf(),
      moment(
        moment()
          .utc()
          .utcOffset(-siteSettingsData?.TimeZoneOffset)
          .subtract(-sliderValue[1], "hours")
      ).valueOf(),
    ];

    sliderState.set(temVal);
  }, [sliderValue]);

  const sliderOnChange = (event, newValue) => {
    if (!Array.isArray(newValue)) {
      return;
    }
    setSliderValue(newValue);
    localStorage.setItem("locationSliderValue", JSON.stringify(newValue));
  };

  return (
    <SliderStyled>
      <Typography
        id="input-slider"
        color="#fff"
        textAlign="center"
        gutterBottom
      >
        {getDate(
          moment()
            .utc()
            .utcOffset(-siteSettingsData?.TimeZoneOffset)
            .subtract(-sliderValue[0], "hours")
        )}{" "}
        -{" "}
        {sliderValue[1] === 0
          ? t("Now")
          : getDate(
            moment()
              .utc()
              .utcOffset(-siteSettingsData?.TimeZoneOffset)
              .subtract(-sliderValue[1], "hours")
          )}
      </Typography>
      <Slider
        getAriaLabel={() => "Temperature"}
        value={sliderValue}
        onChange={sliderOnChange}
        valueLabelDisplay="auto"
        min={-72}
        step={0.25}
        max={0}
        disableSwap
        valueLabelFormat={(val, index) =>
          index === 0 ? (<div className="flex-wrapper"><p>Starting</p><p>location</p></div>) : (<div className="flex-wrapper"><p>Ending</p><p>location</p></div>)
        }
        getAriaValueText={valuetext}
      />
    </SliderStyled>
  );
}

const SliderStyled = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  .flex-wrapper {
    display: flex;
    flex-direction: column;
    text-align: center;
  }
  .MuiSlider-valueLabel {
  font-size: 12px;
 }
  .MuiTypography-root {
    font-family: "Roboto";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 150.5%;
    color: var(--text-primary);
  }
  .MuiSlider-thumb {
    background: var(--input-background);
    width: 18px;
    height: 18px;
    border: 1px solid #cccccc;
    box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.15);
  }
  .MuiSlider-root {
    color: var(--input-background);
    height: 8px;
    border-radius: 20px;
    max-width: calc(100% - 45px);
  }
  .MuiSlider-rail {
    background: var(--input-background);
    opacity: 1;
  }
  .MuiSlider-track {
    color: var(--theme-background);
    height: 8px;
  }
`;
